export default __webpack_public_path__ + "static/teamPerform-4e6d563cd4328983af896655ab043419.png";